export default "__VITE_ASSET__D7vZ$xpA__"